import { useId } from "react";

import { Column } from "@/components";
import { cn } from "@/lib/utils";

const MAX_SIGIL_SIZE_PX = 10;
const SIGIL_HEIGHT_RATIO = 0.45;

export const WinterFinishGate = () => {
  /* React Hooks */
  const id = useId().replace(/:/g, "");

  /* Render */
  const render = () => {
    return (
      <Column className="pointer-events-none absolute -top-3 bottom-0 right-0 z-0 w-20">
        <Column className="absolute inset-y-0 left-1/2 w-8 -translate-x-1/2 bg-gradient-to-r from-sky-200/0 via-sky-100/10 to-sky-200/0 shadow-[0_0_20px_rgba(186,230,253,0.12)]" />
        <svg
          className="absolute inset-0 h-full w-full overflow-visible"
          viewBox="0 0 80 320"
          preserveAspectRatio="none"
          fill="none"
        >
          <defs>
            <linearGradient id={`${id}-iron`} x1="0" x2="1">
              <stop stopColor="#17222d" />
              <stop offset=".45" stopColor="#8d9ca6" />
              <stop offset=".55" stopColor="#445463" />
              <stop offset="1" stopColor="#111b25" />
            </linearGradient>
            <linearGradient id={`${id}-banner`} x1="0" x2="0" y2="1">
              <stop stopColor="#78333e" />
              <stop offset="1" stopColor="#28151f" />
            </linearGradient>
          </defs>
          <path
            d="M14 12H23V306H14ZM57 12H66V306H57Z"
            fill={`url(#${id}-iron)`}
            stroke="#a3b4c1"
            strokeOpacity=".4"
          />
          <path
            d="M10 306H27V314H10ZM53 306H70V314H53Z"
            fill="#3d4d5c"
            stroke="#9aafbe"
            strokeOpacity=".4"
          />
          <path d="M14 15L18 0L23 15ZM57 15L62 0L66 15Z" fill="#99aab6" />
          <path
            d="M8 22H30V65L19 76L8 65ZM50 22H72V65L61 76L50 65Z"
            fill={`url(#${id}-banner)`}
            stroke="#c2a680"
            strokeOpacity=".5"
          />
          <path
            d="M12 26H26V63L19 70L12 63ZM54 26H68V63L61 70L54 63Z"
            stroke="#c1a186"
            strokeOpacity=".35"
          />
          <path
            d="M19 34L24 44L19 54L14 44ZM61 34L66 44L61 54L56 44Z"
            fill="#c3b4a1"
            fillOpacity=".8"
          />
          <path
            d="M23 20Q40 4 57 20M23 27Q40 11 57 27"
            stroke="#a8bac9"
            strokeOpacity=".65"
            strokeWidth="2"
          />
          <path
            d="M40 26V312"
            stroke="#d9f0ff"
            strokeOpacity=".4"
            strokeDasharray="2 6"
          />
          <path
            d="M16 86H21M16 154H21M16 222H21M59 86H64M59 154H64M59 222H64"
            stroke="#bccad4"
            strokeWidth="2"
            strokeOpacity=".6"
          />
        </svg>
        <svg
          className="absolute -top-5 left-1/2 h-9 w-12 -translate-x-1/2 drop-shadow-lg"
          viewBox="0 0 48 36"
          fill="none"
        >
          <path d="M8 31L40 5M8 5L40 31" stroke="#c6d4dd" strokeWidth="2" />
          <path
            d="M7 25L13 32M35 4L41 11M7 11L13 4M35 32L41 25"
            stroke="#738391"
            strokeWidth="3"
          />
          <path
            d="M24 6L37 12V23L24 32L11 23V12Z"
            fill="#17232f"
            stroke="#a5b9c7"
          />
          <path
            d="M17 16L20 20L24 13L28 20L31 16L29 24H19Z"
            fill="#c5d3de"
            stroke="#e3edf3"
            strokeWidth=".5"
          />
        </svg>
      </Column>
    );
  };

  return render();
};

export const WinterFinishSigil = ({
  isFinished,
  laneHeightPx,
}: {
  isFinished: boolean;
  laneHeightPx: number;
}) => {
  /* Render */
  const render = () => {
    const sizePx = Math.min(
      MAX_SIGIL_SIZE_PX,
      laneHeightPx * SIGIL_HEIGHT_RATIO,
    );

    return (
      <Column
        className={cn(
          "-translate-x-6 rotate-45 border",
          isFinished
            ? "border-amber-100 bg-amber-300/70 shadow-[0_0_8px_rgba(251,191,36,0.65)]"
            : "border-sky-100/60 bg-slate-900/80 shadow-[0_0_5px_rgba(186,230,253,0.2)]",
        )}
        style={{ height: sizePx, width: sizePx }}
      />
    );
  };

  return render();
};
